// src/utils/business.js — one place for the business contact details shown on
// the Contact page, Privacy Policy and footer. Keep in sync with the JSON-LD in
// public/index.html and api/_lib/pages.js.
export const BUSINESS = {
  legalName: 'Majority Hair Solution LLC',
  dba: 'The Majorities',
  streetAddress: '11401 Harmon Road',
  city: 'Fort Worth',
  region: 'TX',
  postalCode: '76177',
  country: 'US',
  email: 'ogwutony@themajorities.com',
  phone: '+1-214-534-9122',
  phoneDisplay: '(214) 534-9122',
};
